// Ink income into each TEAM's shared pool (Game.ink[team]; since 2026-09-27, before that per player) —
// docs/game-design.md, "Экономика". Rates live in one block so they can be tuned without touching the
// accrual logic. Kills pay in score, not ink (RULES.killScore in game.ts).
export const INK = {
  perSecond: 0.5,        // flat, to each team's pool — +1 every two seconds (halved 2026-09-23 after playtest)
  perPointPerSecond: 1,  // per capture point the team currently holds (0-3)
} as const;
